export default __webpack_public_path__ + "static/media/Aetna.1d2c5be9.svg";